// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISearchRegionsCitiesRequest,
  TSearchRegionsCitiesModel,
  IMappers,
  TSearchRegionsCitiesResponse,
  ISearchRegionsCitiesResponse,
  ISearchRegionsCitiesResponseError,
} from './types';

export const defaultConfig: TSearchRegionsCitiesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'geo-temp-layer',
  pathApi: '/v1/search-regions-cities/',
} as TSearchRegionsCitiesModel;

export function createSearchRegionsCitiesModel(parameters: ISearchRegionsCitiesRequest): TSearchRegionsCitiesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISearchRegionsCitiesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISearchRegionsCitiesRequest;
}

export async function fetchSearchRegionsCities<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchRegionsCitiesOptions<TResponse200, TResponse400>): Promise<
  TSearchRegionsCitiesResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createSearchRegionsCitiesModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchRegionsCitiesResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ISearchRegionsCitiesResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSearchRegionsCitiesResponse;
}
